<template>
  <div id="app">
    <navbar></navbar>
    <b-container fluid="md">
      <router-view />
    </b-container>
  </div>
</template>

<script>
import Navbar from "@/components/Navbar";

export default {
  name: "App",
  components: { Navbar },
  created() {
    //  eventbus
    this.$bus.$on("i18n-toast", data => {
      const message = this.$t("message." + data.message);
      this.$bvToast.toast(message, {
        autoHideDelay: 3000,
        variant: data.variant,
        appendToast: true,
        noCloseButton: true,
        solid: true
      });
    });

    let lang = this.$route.query.lang;
    if (!lang) {
      lang = (navigator.language || "").startsWith("zh") ? "zh" : "en";
    }
    this.$store.commit("i18n/setLocale", lang);
    this.$root.$i18n.locale = lang;
    this.$store.dispatch("user/getUserInfo");
    this.initTitle();
  },
  destroyed() {
    this.$bus.$off("lang-toast");
  },
  watch: {
    "$route.path"() {
      // set title
      this.initTitle();
    }
  },
  methods: {
    initTitle() {
      if (!this.$route.meta.title) {
        document.title = this.$t("title.base");
      } else {
        document.title =
          this.$t("title.base") +
          "-" +
          this.$t("title." + this.$route.meta.title);
      }
    }
  }
};
</script>

<style lang="scss">
html,
body {
  height: 100%;
}

@import "@/assets/scss/base.scss";
</style>
